<template>
  <el-dialog
      :title="fullNameTitle"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="5vh"
  >
    <el-form
        label-width="120px"
        :model="attendanceKid"
        label-position="top"
        ref="attendanceKid"
    >
      <el-row :gutter="20" style="margin-top:10px">
        <el-col :span="24">

          <!-- Phần CHẤM CÔNG ĐẾN -->
          <div class="shift-card">
            <div class="shift-header">
              <strong>Chấm công đến</strong>
            </div>

            <div class="shift-row">
              <!-- Ảnh đến -->
              <div class="shift-col shift-media">
                <div class="shift-media-title">Ảnh đến</div>
                <image-uploader
                    v-model="dummyCheckinImage"
                    :preview="attendanceKid.attendanceDetail?.arrivePicture"
                    placeholder="Chưa có ảnh đến"
                    :disabled="true"
                    :show-upload="false"
                    :deletable="false"
                />
                <div class="shift-time">
                  Giờ đến: <span>{{ attendanceKid.attendanceDetail?.arriveTime | formatTime }}</span>
                </div>
              </div>

              <!-- Ghi chú đến + thông tin -->
              <div class="shift-col shift-note">
                <div class="shift-media-title">Ghi chú đến</div>
                <el-input
                    type="textarea"
                    :rows="4"
                    v-model="attendanceKid.attendanceDetail.arriveContent"
                    disabled
                />

                <!-- Thông tin người thực hiện (ưu tiên hiển thị ở phần Đến nếu có) -->
                <div class="shift-status" style="margin-top: 16px;" v-if="attendanceKid.attendanceDetail?.idCreated != null">
                  <div v-if="attendanceKid.attendanceDetail.createdDate !== attendanceKid.attendanceDetail.lastModifieDate">
                    <strong>Chấm công:</strong> {{ attendanceKid.attendanceDetail.lastModifieBy }}
                    <div style="margin-top: 4px;" v-if="attendanceKid.attendanceDetail.lastModifieBy !== 'Hệ thống'">
                      <strong>Thời gian:</strong> {{ attendanceKid.attendanceDetail.lastModifieDate | formatDateTime }}
                    </div>
                  </div>
                  <div v-else>
                    <strong>Chấm công:</strong> {{ attendanceKid.attendanceDetail.createdBy }}
                    <div style="margin-top: 4px;" v-if="attendanceKid.attendanceDetail.createdBy !== 'Hệ thống'">
                      <strong>Thời gian:</strong> {{ attendanceKid.attendanceDetail.createdDate | formatDateTime }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Phần CHẤM CÔNG VỀ (chỉ hiển thị nếu có dữ liệu về) -->
          <div class="shift-card" v-if="attendanceKid.attendanceDetail?.leaveTime">
            <div class="shift-header">
              <strong>Chấm công về</strong>
            </div>

            <div class="shift-row">
              <!-- Ảnh về -->
              <div class="shift-col shift-media">
                <div class="shift-media-title">Ảnh về</div>
                <image-uploader
                    v-model="dummyCheckoutImage"
                    :preview="attendanceKid.attendanceDetail?.leavePicture"
                    placeholder="Chưa có ảnh về"
                    :disabled="true"
                    :show-upload="false"
                    :deletable="false"
                />
                <div class="shift-time">
                  Giờ về: <span>{{ attendanceKid.attendanceDetail?.leaveTime | formatTime }}</span>
                </div>
              </div>

              <!-- Ghi chú về -->
              <div class="shift-col shift-note">
                <div class="shift-media-title">Ghi chú về</div>
                <el-input
                    type="textarea"
                    :rows="4"
                    v-model="attendanceKid.attendanceDetail.leaveContent"
                    disabled
                />
              </div>
            </div>
          </div>

        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button
          type="danger"
          size="medium"
          @click="closeDialogByButton('attendanceKid')"
      >
        <i class="el-icon-circle-close"/> Đóng
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import ImageUploader from "@/utils/view/ImageUploader.vue";

export default {
  name: "AttendanceViewDialog",
  components: {
    ImageUploader
  },
  props: {
    dialogVisible: { type: Boolean, default: false },
  },
  data() {
    return {
      attendanceKid: {
        attendanceDetail: {}
      },
      fullNameTitle: "",
      dummyCheckinImage: null,
      dummyCheckoutImage: null,
    };
  },
  methods: {
    closeDialog() {
      this.$emit("dialog-close", false);
      this.resetForm();
    },

    closeDialogByButton() {
      this.closeDialog();
    },

    resetForm() {
      if (this.$refs["attendanceKid"]) {
        setTimeout(() => {
          this.$refs["attendanceKid"].resetFields();
        }, 200);
      }
      this.attendanceKid = { attendanceDetail: {} };
      this.fullNameTitle = "";
    },

    getDataArriveRowInitial(row) {
      this.attendanceKid = row;
      this.fullNameTitle = "Thông tin chấm công đến và về: " + (row.infoEmployeeResponse?.fullName || "");
    },
  }
};
</script>

<style scoped>
/* Giữ nguyên style từ phiên bản trước, copy thêm từ Code 1 nếu cần */

.shift-card {
  padding: 18px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
}

.shift-header {
  font-size: 18px;
  margin-bottom: 12px;
  color: #1f74d4;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
}

.shift-row {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.shift-col {
  display: flex;
  flex-direction: column;
}

.shift-media {
  width: 180px;
  align-items: center;
  text-align: center;
}

.shift-note {
  flex: 1;
}

.shift-media-title {
  font-weight: 600;
  margin-bottom: 8px;
  color: #303133;
}

.shift-time {
  margin-top: 10px;
  color: #4177e2;
  font-size: 16px;
  font-weight: 500;
}

.shift-status {
  margin-top: 20px;
  font-size: 13px;
  line-height: 1.6;
}

.shift-status strong {
  color: #1f74d4;
}

/* Dialog chung */
::v-deep .el-dialog__body {
  max-height: 72vh;
  overflow-y: auto;
  background: #fafbff;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #4da3ff, #1f74d4);
  padding: 16px 20px !important;
}

::v-deep .el-dialog__title {
  color: white !important;
  font-size: 20px !important;
  font-weight: bold;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
}

::v-deep .el-dialog__footer {
  background: #f5f7fa;
  padding: 14px 20px !important;
  border-top: 1px solid #dcdfe6;
}

::v-deep .el-button--danger:hover {
  background: #ff6b6b;
  border-color: #ff6b6b;
}
</style>